// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import PushNotificationsController from "./push_notifications_controller"
application.register("push-notifications", PushNotificationsController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import SiteNavController from "./site_nav_controller"
application.register("site-nav", SiteNavController)

import SubmitGuardController from "./submit_guard_controller"
application.register("submit-guard", SubmitGuardController)

import VerificationPollController from "./verification_poll_controller"
application.register("verification-poll", VerificationPollController)
